import { Box, Spinner } from '@ouster/webviz-react-components';

import { RiShieldUserLine } from 'react-icons/ri';

import DashboardCard from './DashboardCard';
import InfoItem from './InfoItem';
import { InfoItemType, KeycloakUserInfo } from './types';
import { formatDate } from './utils';

interface UserLookUpKeycloakInfoProps {
  keycloakUserInfo: KeycloakUserInfo[] | null;
  isLoadingUserLookup: boolean;
  isUserFound: boolean;
}

export default function UserLookUpKeycloakInfo({
  keycloakUserInfo,
  isLoadingUserLookup,
  isUserFound,
}: UserLookUpKeycloakInfoProps) {
  const cardProps = {
    icon: <RiShieldUserLine size={20} />,
    title: 'Keycloak User',
  };

  if (isLoadingUserLookup) {
    return (
      <DashboardCard {...cardProps}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          my={8}
          data-testid="user-lookup-keycloak-loading"
        >
          <Spinner />
        </Box>
      </DashboardCard>
    );
  }

  if (!isUserFound) return null;

  const keycloakUser = keycloakUserInfo?.[0];

  if (!keycloakUserInfo || !keycloakUser) {
    return (
      <DashboardCard {...cardProps}>
        <Box my={8} data-testid="user-lookup-keycloak-empty">
          User does not exist in Keycloak
        </Box>
      </DashboardCard>
    );
  }

  const fullName = `${keycloakUser.firstName} ${keycloakUser.lastName}`;

  const userInfoItems: InfoItemType[] = [
    { label: 'Username', value: keycloakUser.username },
    { label: 'Full Name', value: fullName },
    {
      label: 'Enabled',
      value: keycloakUser.enabled ? 'True' : 'False',
      color: keycloakUser.enabled ? 'success' : 'error',
    },
    {
      label: 'Email Verified',
      value: keycloakUser.emailVerified ? 'True' : 'False',
      color: keycloakUser.emailVerified ? 'success' : 'error',
    },
    {
      label: 'Created',
      value: formatDate(Number(keycloakUser.createdTimestamp)),
    },
  ];

  return (
    <DashboardCard {...cardProps} data-testid="user-lookup-keycloak-card">
      <Box
        display="grid"
        gridTemplateColumns="repeat(3, 1fr)"
        columnGap={4}
        rowGap={6}
        data-testid="user-lookup-keycloak-grid"
      >
        {userInfoItems.map((item) => (
          <InfoItem
            key={item.label}
            label={item.label}
            value={item.value}
            color={item.color}
            data-testid={`user-lookup-keycloak-item-${item.label
              .toLowerCase()
              .replace(/\s/g, '-')}`}
          />
        ))}
      </Box>
    </DashboardCard>
  );
}
